/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a profile picture.
 * @export
 * @interface UserAvatar
 */
export interface UserAvatar {
    /**
     * URL of customer profile image in media server. It's optional.
     * @type {string}
     * @memberof UserAvatar
     */
    url?: string;
    /**
     * Image format. It's optional.
     * @type {string}
     * @memberof UserAvatar
     */
    format?: string;
}

/**
 * Check if a given object implements the UserAvatar interface.
 */
export function instanceOfUserAvatar(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserAvatarFromJSON(json: any): UserAvatar {
    return UserAvatarFromJSONTyped(json, false);
}

export function UserAvatarFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAvatar {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'format': !exists(json, 'format') ? undefined : json['format'],
    };
}

export function UserAvatarToJSON(value?: UserAvatar | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'format': value.format,
    };
}

